import React, {createContext, useContext, useEffect, useState} from 'react';
import {Form} from "antd";
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {onChangeSuccessAxios} from "../../../redux/actions/axios/Action";
import {useModalContext} from "../../feedback/modal";
import {onChangeForbidden} from "../../../redux/actions/action-history/Action";
import {getEmployeeCurrentByEmployeeId} from "../../../api/hrm/personel/record/career/api";

export const DG_FormContext = createContext({})

export const useDG_FormContext = () => useContext(DG_FormContext)

const DG_Form = props => {

    const {t} = useTranslation()
    const {successAxios} = useSelector(state => state.axiosReducer)
    const enabled = useSelector(state => state.layoutInteractionReducer.actions?.actions?.enabled)

    const mode = props.mode;
    const form = props.form;
    const success = props.success !== undefined ? props.success : successAxios
    const [isChild, setIsChild] = useState(false)
    const [employeeId, setEmployeeId] = useState()
    const [employeeCurrent, setEmployeeCurrent] = useState()
    const [upload, setUpload] = useState(false)
    const dispatch = useDispatch()

    const modalContext = useModalContext()

    useEffect(() => {
        if (!enabled && props?.permission !== undefined)
            dispatch(onChangeForbidden(true))
    }, [enabled])

    useEffect(() => {
        if (employeeId)
            getEmployeeCurrentByEmployeeId(employeeId).then((response) => {
                setEmployeeCurrent(response)
            })
    }, [employeeId])


    useEffect(() => {
        if (modalContext?.setMode) {
            modalContext?.setMode(mode)
            modalContext?.setForm(form)
            setIsChild(true)

        }
    }, [modalContext])


    const onChangeSuccessLocal = () => {
        if (props.onChangeSuccess) return props.onChangeSuccess()
        else return dispatch(onChangeSuccessAxios(false))
    }


    const validateMessages = {
        required: "${label}" + " " + t('common.required'),
    };

    return (
        <Form
            layout="vertical"
            form={form}
            validateMessages={validateMessages}
            {...props}
        >

            <div style={{marginBottom: 24, height: '100%', overflow: 'hidden'}}>
                <DG_FormContext.Provider
                    value={isChild ? {
                            mode,
                            form,
                            setEmployeeId,
                            employeeId,
                            employeeCurrent,
                            upload,
                            setUpload
                        } :
                        {
                            mode, form, success, onChangeSuccess: onChangeSuccessLocal,
                            setEmployeeId, employeeId,
                            employeeCurrent,
                            upload,
                            setUpload
                        }}>
                    {props.children}
                </DG_FormContext.Provider>
            </div>


        </Form>
    );
};

DG_Form.propTypes = {
    form: PropTypes.any.isRequired,
    mode: PropTypes.string.isRequired,
    success: PropTypes.bool,
    onChangeSuccess: PropTypes.func
};

export default DG_Form;